/*
 * pusher实时更新
 */

import resourceSubject from 'next/javascripts/reactivity/resource-subject';
import createPusher from 'next/javascripts/modules/pusher/create';

(function($) {

  $(function() {
    var curMemberId = tower.me.id;
    var channelName = process.env.PUSHER_CHANNEL_PREFIX + curMemberId;
    var connectionId = $('#conn-guid').val();

    if (!tower.me || !tower.me.guid) {
      return;
    }

    const socket = createPusher();

    var mychannel = socket.subscribe(channelName);

    // desktop notification
    mychannel.bind('client-notify', function(data) {
      tower.updateNoticeCount(data.unread_count);

      if (data.op === 'ADD' && data.desktop_notifiable == true) {
        d18n(data);
      }

      updateUnreadPopover(data);
    });

    // team events
    mychannel.bind('event', function(data) {
      var pageEl = $('.workspace .page:last .page-inner');
      if (!pageEl.is('#page-events')) {
        return;
      }

      // 如果当前有成员和项目的过滤条件就需要判断是否显示
      var byMemberGuid = simple.url().getParam('by_member');
      var eventCreatorGuid = data.event.creator.guid;
      if (/[0-9a-z]{32}/.test(byMemberGuid) && eventCreatorGuid !== byMemberGuid) {
        return
      }

      var byProjectGuid = simple.url().getParam('by_project'),
          eventProjectGuid = data.event.ancestor.guid;
      if (/[0-9a-z]{32}/.test(byProjectGuid) && eventProjectGuid !== byProjectGuid) {
        return
      }

      var $eventEl;
      try {
        $eventEl = $($.trim(data.html));
      } catch (e) {
        $eventEl = null;
      }

      // Fix: 消除 Pusher 影响的产生的多条信息
      if ($('#event-' + $eventEl.attr('id')).length) {
        return;
      }

      tower.initEventList($eventEl, true);

      tower.adjustReadableDate($eventEl);
      tower.adjustEventsDate($eventEl);
      tower.adjustCreatedAtTime($eventEl);
      tower.highlight($eventEl);
    });


    // detail page comments
    mychannel.bind('comment', function(comment) {
      if (comment.conn_guid === connectionId) {
        return;
      }

      var pageIds = {
        'Todo': 'page-todo',
        'Document': 'page-doc',
        'Message': 'page-message',
        'Upload': 'page-file',
        'CalendarEvent': 'page-calendar-event',
        'Todolist': 'page-todolist',
        'Report': 'reports-answers-show'
      };
      var pageEl = $('.workspace .page:last .page-inner');
      var pageId = pageEl.attr('id');
      if (pageId !== pageIds[comment.commentable.type] ||
          comment.commentable.guid !== pageEl.data('page-guid')) {
        return;
      }

      var commentsEl = $(".comments");
      var commentEl;

      if (!commentsEl.length) {
        return;
      }

      if (comment.op === 'create') {
        commentEl = commentsEl.find('#' + comment.guid);
        if (commentEl.length) {
          commentEl.remove();
        }

        commentEl = $(comment.html);

        commentEl.appendTo(commentsEl);
        tower.adjustReadableTime(commentEl);
      } else if (comment.op === 'delete') {
        commentsEl.find("#" + comment.guid).fadeOut(function() {
          $(this).remove();
        });
      } else if (comment.op === 'update') {
        commentEl = $(comment.html);
        var oldCommentEl = commentsEl.find("#" + comment.guid);

        if (oldCommentEl.length) {
          oldCommentEl.replaceWith(commentEl);
        } else {
          commentEl.appendTo(commentsEl);
        }

        tower.adjustReadableTime(commentEl);
      }

      if (commentEl && commentEl.length) {
        tower.initPermission();
        tower.highlight(commentEl);
      }
    });

    // documents
    mychannel.bind('document', function(doc) {
      if (doc.conn_guid === connectionId) {
        return;
      }

      var pageEl = $('.workspace .page:last .page-inner');
      if (pageEl.is('#page-doc') && $('#page-doc').data('page-guid') == doc.guid && !/version/.test(location.href)) {
        if (doc.op === 'edit' && tower.me.guid !== doc.current_editor.guid) {
          pageEl.find('.detail-action-edit-real').addClass('hide');
          pageEl.find('.detail-action-edit')
            .removeClass('hide')
            .attr('data-tooltip', doc.current_editor.nickname + ' 正在编辑');
          tower.checkEditLock(true);
        } else if (doc.op === 'save') {
          pageEl.find('.detail-action-edit').addClass('hide');
          pageEl.find('.detail-action-edit-real').removeClass('hide');
          tower.checkEditLock(false);
        }
      }

      if ($.inArray(pageEl.attr('id'), ['page-docs', 'page-project', 'page-documentdirs']) < 0 ||
          doc.project_guid !==  pageEl.data('project-guid')) {
        return;
      }

      var docsEl = $(".doc-list");
      if (!docsEl.length) {
        return;
      }

      var docEl = $(doc.html);
      var dirGuid = pageEl.data('doc-dir-guid') || 0;
      var initEl = $('.init.init-docs');

      if (doc.op === 'create' && doc.doc_dir_guid === dirGuid) {
        docsEl.find(".doc-item[data-guid=" + doc.guid + "]").remove();
        docsEl.prepend(docEl);
        initEl.hide();
        docsEl.closest('.docs-view').show();
      } else if (doc.op === 'delete') {
        docsEl.find(".doc-item[data-guid=" + doc.guid + "]").fadeOut(function() {
          $(this).remove();
          if (!docsEl.children().length) {
            initEl.show();
            docsEl.closest('.docs-view').hide();
          }
        });
      } else if (doc.op === 'update') {
        var oldDocEl = docsEl.find('.doc-item[data-guid=' + doc.guid + ']');
        if (doc.doc_dir_guid === dirGuid) {
          if (oldDocEl.length === 0) {
            docsEl.prepend(docEl);
          } else {
            oldDocEl.remove();
            docsEl.prepend(docEl);
          }
        } else {
          oldDocEl.fadeOut(function() {
            $(this).remove();
            if (!docsEl.children().length) {
              initEl.show();
              docsEl.closest('.docs-view').hide();
            }
          });
        }
      }

      if (docEl && docEl.length) {
        tower.highlight(docEl);
        tower.adjustReadableTime(docEl);
      }

      if ($('#page-project').length) {
        docsEl.find(".doc-or-dir:gt(5)").remove();
      }
    });

    //documentdirs
    mychannel.bind('document_dir', function(doc_dir) {
      if (doc_dir.conn_guid === connectionId) {
        return;
      }

      var pageEl = $('.workspace .page:last .page-inner');
      if ($.inArray(pageEl.attr('id'), ['page-docs', 'page-documentdirs', 'page-project']) < 0 ||
        doc_dir.project_guid !==  pageEl.data('project-guid')) {
        return;
      }

      var docsEl = $('.docs-view .doc-list');
      if (!docsEl.length) {
        return;
      }

      var docDirEl = $(doc_dir.html);
      var initEl = $('.init.init-docs');
      var dirGuid = pageEl.data('doc-dir-guid') || 0;

      if (doc_dir.op === 'create' && doc_dir.parent_dir_guid === dirGuid) {
        docDirEl.prependTo(docsEl);
        initEl.hide();
        docsEl.closest('.docs-view').show();
      } else if (doc_dir.op === 'delete') {
        docsEl.find('.doc-dir-item[data-guid=' + doc_dir.guid + ']').fadeOut(function() {
          $(this).remove();
          if (!docsEl.children().length) {
            initEl.show();
            docsEl.closest('.docs-view').hide();
          }
        });
      } else if (doc_dir.op === 'update') {
        var oldDocDirEl = docsEl.find('.doc-dir-item[data-guid=' + doc_dir.guid + ']');
        if (doc_dir.parent_dir_guid === dirGuid) {
          if (oldDocDirEl.length === 0) {
            docsEl.prepend(docDirEl);
          } else {
            oldDocDirEl.remove();
            docsEl.prepend(docDirEl);
          }
        } else {
          oldDocDirEl.fadeOut(function() {
            $(this).remove();
            if (!docsEl.children().length) {
              initEl.show();
              docsEl.closest('.docs-view').hide();
            }
          });
        }
      }
      if (docDirEl && docDirEl.length) {
        tower.highlight(docDirEl);
        tower.adjustReadableTime(docDirEl);
      }

      if ($('#page-project').length < 1) {
        docDirEl.find('a[data-stack]').attr('data-stack-replace', 'true');
      } else {
        docsEl.find(".doc-or-dir:gt(5)").remove();
      }
    });

    // topics
    mychannel.bind('topic', function(topic) {
      if (topic.conn_guid === connectionId) {
        return;
      }

      var pageEl = $('.workspace .page:last .page-inner');
      if ($.inArray(pageEl.attr('id'), ['page-topics', 'page-project']) < 0 ||
        topic.project_guid !==  pageEl.data('project-guid')) {
        return;
      }

      var messagesEl = $(".messages");
      if (!messagesEl.length) {
        return;
      }

      var messageEl;
      if (topic.op === 'delete') {
        messagesEl.find(".message[data-guid=" + topic.guid + "]").fadeOut(function() {
          $(this).remove();
        });
      } else if (topic.op === 'create') {
        messageEl = $(topic.html).hide();
        messagesEl.find("[data-guid=" + topic.guid + "]").remove();
        messagesEl.prepend(messageEl);
        messagesEl.find('.sticky').prependTo(messagesEl);
        messageEl.show();
        tower.adjustReadableTime(messageEl);
        $('.init.init-discussion').hide();
      } else if (topic.op === 'update') {
        messageEl = $(topic.html).hide();
        messagesEl.find("[data-guid=" + topic.guid + "]").remove();
        messagesEl.prepend(messageEl);
        messagesEl.find('.sticky').prependTo(messagesEl);
        messageEl.show();
        tower.adjustReadableTime(messageEl);
      }

      if (pageEl.is("#page-project")) {
        messagesEl.find(".message:gt(2)").hide();
        messagesEl.find(".message:lt(3)").show();
      }

      if (messageEl && messageEl.length) {
        tower.highlight(messageEl);
      }
    });

    // todos
    mychannel.bind('todo', function(todo) {
      // 任务清单成员视图时需要通过 pusher 更新
      if (todo.conn_guid === connectionId) {
        return;
      }

      const { op: eventName, ...todoData } = todo;
      resourceSubject('todo').next(`${eventName}:pusher`, todoData);

      var pageEl = $('.workspace .page:last .page-inner');
      var isKanban = pageEl.hasClass('project-kanban');
      var pageId = pageEl.attr('id');

      if (pageId === 'page-member') {
        return;
      } else if (todo.parent_id) {
        // 当parent_id存在时进入子任务的处理逻辑
        handleSubTodoEvent(todo);
        return;
      }

      if (!($.inArray(pageId, ['page-todolists', 'page-project']) > -1 && todo.project_guid ===  pageEl.data('project-guid')) &&
          !(pageId === 'page-todolist' && $('#page-todolist').data('page-guid') == todo.list)) {
        return;
      }

      var todoEl = isKanban ? $(todo.kanban_html) : $(todo.html);;
      var needResort = [];

      if (todo.op === 'create') {
        var kanban = document.querySelector('tr-project-kanban');
        if (kanban) {
          if (['assignee', 'creator'].indexOf(kanban.groupBy) > -1) {
            return;
          }
        }

        if (!todo.list) {
          return;
        }

        var todolistEl = $(".todolist[data-guid=" + todo.list + "]");
        var oldTodoEl = todolistEl.find(".todo[data-guid=" + todo.guid + "]");
        var completed = todoEl.hasClass("completed");

        if (oldTodoEl.length) {
          oldTodoEl.remove();
        }

        todolistEl.find(completed ? ".todos-completed" : ".todos-uncompleted").append(todoEl);
        needResort.push(todolistEl[0]);

        pageEl.trigger('todocreate', [null, null, todoEl, todolistEl]);

        tower.adjustTodo(todoEl);
        tower.adjustReadableDate(todoEl);
        tower.adjustReadableTime(todoEl);
        if (kanban) {
          todolistEl.get(0).updateTodoCount();
        }
        $('.init-todo-empty, .init-todo-completed').remove();
      } else if (todo.op === 'delete') {
        $('.todolists-wrap .todo[data-guid="' + todo.guid + '"]')
          .fadeOut(function() {
            var todoEl = $(this);
            var list = todoEl.closest('.todolist');
            todoEl.remove();
            pageEl.trigger('todoremove', [todoEl, list, null, null]);
          });
      } else if (todo.op === 'update') {
        var oldTodoEl = $('.todolists .todo[data-guid=' + todo.guid + ']');
        var completed = todoEl.hasClass('completed');
        var todolistEl;
        var oldTodolistEl;

        if (todo.list) {
          todolistEl = $('.todolist[data-guid=' + todo.list + ']');
          oldTodolistEl = oldTodoEl.closest('.todolist');
        } else {
          todolistEl = oldTodoEl.closest('.todolist');
        }

        if (completed && !oldTodoEl.closest('.todos-completed').length) {
          oldTodoEl.fadeOut(function() {
            oldTodoEl.remove();
            todolistEl.find('.todos-completed').prepend(todoEl);

            tower.adjustTodo(todoEl);
            tower.adjustReadableDate(todoEl);
            tower.adjustReadableTime(todoEl);
          });
        } else {
          oldTodoEl
            .hide('fast')
            .before(todoEl)
            .remove();

          tower.adjustTodo(todoEl);
          tower.adjustReadableDate(todoEl);
          tower.adjustReadableTime(todoEl);
        }

        pageEl.trigger('todoupdate', [oldTodoEl, oldTodolistEl, todoEl, todolistEl]);

        if (!todolistEl.length) {
          return;
        }

        // 看板中不需要重新排序
        if(!isKanban && todo.sequence_changed) {
          needResort.push(todolistEl[0]);
        }
      }

      $.each($.unique(needResort), function(i, todolistEl) {
        var todoWrap = $(todolistEl).find('.todos-uncompleted');
        var completedWrap = $(todolistEl).find('.todos-completed');
        var todoEls = todoWrap.children('.todo');
        var completedEls = completedWrap.children('.todo');

        todoEls.sort(ascFn);
        completedEls.sort(ascFn);

        if (isKanban) {
          todoWrap.prepend(todoEls);
        } else {
          todoWrap.append(todoEls);
        }
        completedWrap.append(completedEls);
      });

      if (todoEl && todoEl.length) {
        tower.highlight(todoEl);
      }
    });

    // todolists
    mychannel.bind('todolist', function(todolist) {
      if (todolist.conn_guid === connectionId) {
        return;
      }

      var pageEl = $('.workspace .page:last .page-inner');
      var isKanban = pageEl.hasClass('project-kanban');
      if ($.inArray(pageEl.attr('id'), ['page-todolists', 'page-project']) < 0 ||
        todolist.project_guid !==  pageEl.data('project-guid')) {
        return;
      }

      var todolistsEl = $(".todolists");
      if (!todolistsEl.length) {
        return;
      }

      if (todolist.op === 'create') {
        if (todolist.is_default) {
          return;
        }

        var todolistEl = isKanban ? $(todolist.kanban_html) : $(todolist.html);
        var oldEl = todolistsEl.find(".todolist[data-guid=" + todolist.guid + "]");

        if (oldEl.length) {
          oldEl.replaceWith(todolistEl);
        } else {
          todolistsEl.prepend(todolistEl);
        }

        $('.init-todo-empty, .init-todo-completed').remove();
      } else if (todolist.op === 'delete') {
        todolistsEl.find(".todolist[data-guid=" + todolist.guid + "]")
          .fadeOut(function() {
            $(this).remove();
          });
      } else if (todolist.op === 'update') {
        var todolistEl = todolistsEl.find("[data-guid=" + todolist.guid + "]");

        if (todolist.name) {
          if (isKanban) {
            var title = $(todolist.html).find('.name-non-linkable').html();
            todolistEl.find('.todolist-title-name').html(title);
          } else {
            todolistEl.find('.title .desc').remove();
            todolistEl.find(".title h4").replaceWith(todolist.name);
          }
        }

        if (todolist.position) {
          todolistEl.data("sort", todolist.position);
        }
      }
    });

    // files
    mychannel.bind('file', function(file) {
      if (file.conn_guid === connectionId) {
        return;
      }

      var pageEl = $('.workspace .page:last .page-inner');
      if ($.inArray(pageEl.attr('id'), ['page-attachments', 'page-folder', 'page-project', 'page-default-dir']) < 0 ||
        file.project_guid !==  pageEl.data('project-guid')) {
        return;
      }

      var filesEl = $('.files-view .file-list:first');
      if (!filesEl.length) {
        return;
      }

      var fileEl = $(file.html);
      var initEl = $('.init.init-file');
      var dirGuid = pageEl.data('dir-guid') || 0;

      if (file.op === 'create') {
        if (pageEl.is('#page-default-dir')) {
          filesEl.prepend(fileEl)
            .closest(".day")
            .show();
          initEl.hide();
          filesEl.closest('.files-view').show();
        } else if (file.parent_dir_guid === dirGuid) {
          fileEl.prependTo(filesEl);
          initEl.hide();
          filesEl.closest('.files-view').show();
        }

      } else if (file.op === 'delete') {
        $('.file[data-guid=' + file.guid + ']').fadeOut(function() {
          filesEl = $(this).closest('.file-list');
          $(this).remove();
          if (pageEl.is('#page-default-dir') && !filesEl.children().length) {
            filesEl.closest('.day').hide();
          } else if (!filesEl.children().length) {
            initEl.show();
            filesEl.closest('.files-view').hide();
          }
        });

      } else if (file.op === 'update') {
        var oldFileEl = $('.file[data-guid=' + file.guid + ']');

        if (file.parent_dir_guid === dirGuid || pageEl.is('#page-default-dir')) {
          if (oldFileEl.length) {
            oldFileEl.replaceWith(fileEl);
          } else {
            filesEl.prepend(fileEl);
          }
        } else {
          oldFileEl.fadeOut(function() {
            $(this).remove();
            if (!filesEl.children().length) {
              initEl.show();
              filesEl.closest('.files-view').hide();
            }
          });
        }
      }

      //if (pageEl.is('#page-project')) {
      //filesEl.children(':gt(9)').hide();
      //}

      if (fileEl && fileEl.length) {
        tower.highlight(fileEl);
      }

      tower.adjustReadableTime(fileEl);

      if ($('.page#page-project').length < 1) {
        fileEl.find('a[data-stack]').attr('data-stack-replace', 'true')
      }
    });

    // dir
    mychannel.bind('dir', function(dir) {
      if (dir.conn_guid === connectionId) {
        return;
      }

      var pageEl = $('.workspace .page:last .page-inner');
      if ($.inArray(pageEl.attr('id'), ['page-attachments', 'page-folder', 'page-project']) < 0 ||
        dir.project_guid !==  pageEl.data('project-guid')) {
        return;
      }

      var filesEl = $('.files-view .file-list');
      if (!filesEl.length) {
        return;
      }

      var folderEl = $(dir.html);
      var initEl = $('.init.init-file');
      var dirGuid = pageEl.data('dir-guid') || 0;

      if (dir.op === 'create' && dir.parent_dir_guid === dirGuid) {
        folderEl.prependTo(filesEl);
        initEl.hide();
        filesEl.closest('.files-view').show();
      } else if (dir.op === 'delete') {
        filesEl.find('.dir[data-guid=' + dir.guid + ']').fadeOut(function() {
          $(this).remove();
          if (!filesEl.children().length) {
            initEl.show();
            filesEl.closest('.files-view').hide();
          }
        });

      } else if (dir.op === 'update') {
        var oldFolderEl = filesEl.find('.dir[data-guid=' + dir.guid + ']');
        var is_empty = $(dir.html).hasClass('empty')
        // 因为 folderEl 有 droppable class 所以不直接替换
        if (dir.parent_dir_guid === dirGuid) {
          if (oldFolderEl.length === 0) {
            filesEl.prepend(folderEl);
          } else if (is_empty && !oldFolderEl.hasClass('empty')) {
            oldFolderEl.addClass('empty');
          }
        } else {
          oldFolderEl.fadeOut(function() {
            $(this).remove();
            if (!filesEl.children().length) {
              initEl.show();
              filesEl.closest('.files-view').hide();
            }
          });
        }
      }

      //if (pageEl.is('#page-project')) {
      //filesEl.children(':gt(9)').hide();
      //}

      if (folderEl && folderEl.length) {
        tower.highlight(folderEl);
      }

      if ($('#page-project').length < 1) {
        folderEl.find('a[data-stack]').attr('data-stack-replace', 'true')
      }

      tower.adjustReadableTime(folderEl);
    });

    // custom background.
    mychannel.bind('upload_custom_background', function(custom_background_info) {
      if (custom_background_info.conn_guid == connectionId) {
        // Hide progress.
        $(".upload-progress").hide();

        // Update re-upload attributes.
        $(".re-upload-thumbnail-background").attr("src", custom_background_info.oss_thumbnail_url)
        $(".re-upload-item").show();

        // Update background attributes.
        $("#custom_background_type").val("upload_background");
        $("#custom_background_index").val("1");

        // Update background image.
        tower.updateCustomBackgroundImage(
          custom_background_info.oss_url,
          custom_background_info.oss_url,
          custom_background_info.top_brightness,
          custom_background_info.bottom_brightness
        );
      }
    });

    // export doc
    mychannel.bind('export_document', function(result) {
      if (result.conn_guid != connectionId ) {
        return;
      }

      if (result.success) {
        location.href = result.url;
        var linkExportDoc = $("#link-export-doc");
        if (linkExportDoc) {
          linkExportDoc.text('导出').prop("disabled", false).toggleClass("export-waiting");
        }
      }
    });

    // export data
    mychannel.bind('exporter', function(exporter) {
      if (exporter.conn_guid === connectionId) {
        return;
      }

      var pageEl = $('.workspace .page:last .page-inner');
      if (!pageEl.is('#page-team-settings')) {
        return;
      }

      var exportSection = $('.export-section');
      exportSection.find('p').remove()
        .end()
        .append('<p class="desc completed">数据备份的下载链接已在 <span data-readable-time="' + exporter.created_at + '"></span>\
                发送到 ' + $('#user-email').val() + '，请查收邮件后下载。');
      tower.adjustReadableTime();
    });

    // authorize member
    mychannel.bind("authorize_member", function(data) {
      if (data.authorize_member_count == 0) {
        $('.system-message.authorize_member').remove();
      }
      if (data.authorize_member_count > 0) {
        if ($('.system-message.authorize_member').length == 0) {
          $(data.html).prependTo(".wrapper");
        } else {
          $('.system-message.authorize_member').remove();
          $(data.html).prependTo(".wrapper");
        }

        //如果当前已经处在[加入申请]页面之中,则替换掉当前stack
        if ($('#page-members').length > 0) {
          $(".system-message.authorize_member .process-message").attr("data-stack-replace", true);
        }

      }
    });

    // 从模板生成项目，数据生成是异步，所以完成后要通知客户端
    mychannel.bind('project_clone', function(data) {
      var dialog = $('.' + data.guid);
      if (!dialog.length) return;

      if (data.is_template) {
        tower.stack.load(data.project_url, {
          root: true
        });
      } else {
        location.href = data.project_url;
      }
    });

    // 蓝湖设计板
    mychannel.bind('lanhu_design', function(data) {
      if (data.conn_guid === connectionId) {
        return;
      }

      var pageEl = $('.workspace .page:last .page-inner');
      if ($.inArray(pageEl.attr('id'), ['page-lanhu-designs']) < 0 ||
        data.project_guid !==  pageEl.data('project-guid')) {
        return;
      }

      var filesEl = $(".file-list");
      if (!filesEl.length) {
        return;
      }

      var fileEl = $(data.html);
      var fileGuid = pageEl.data('file-guid') || 0;
      var initEl = $('.init.init-file');

      if (data.op === 'create') {
        filesEl.find(".file-or-dir[data-guid=" + data.guid + "]").remove();
        filesEl.prepend(fileEl);
        initEl.hide();
        filesEl.closest('.files-view').show();
      } else if (data.op === 'delete') {
        filesEl.find(".file-or-dir[data-guid=" + data.guid + "]").fadeOut(function() {
          $(this).remove();
          if (!filesEl.children().length) {
            filesEl.closest('.files-view').hide();
            initEl.show();
          }
        });
      } else if (data.op === 'update') {
        var oldFileEl = filesEl.find('.file-or-dir[data-guid=' + data.guid + ']');
        if (oldFileEl.length === 0) {
          docsEl.prepend(docEl);
        } else {
          oldFileEl.remove();
          filesEl.prepend(fileEl);
        }
      }

      if (fileEl && fileEl.length) {
        tower.highlight(fileEl);
        tower.adjustReadableTime(fileEl);
      }
    })

    // check_item
    mychannel.bind('check_item', function(check_item) {
      if (check_item.conn_guid === connectionId) {
        return;
      }

      var pageEl = $('.workspace .page:last .page-inner');
      var pageId = pageEl.attr('id');

      if (pageId === 'page-todo' && $('#page-todo').data('page-guid') == check_item.todo_guid) {
        var checkItemEl;
        var checkItems = pageEl.find('.check-items');

        if (check_item.op === 'create') {
          checkItemEl = $(check_item.html);

          checkItems.find('.link-add-check-item').before(checkItemEl)

          tower.initCheckItem(checkItemEl, { willRemoveLink: $('#page-todo').length ? true : false })
        } else if (check_item.op === 'delete') {
          checkItems.find('.check-item[data-guid=' + check_item.guid + ']')
            .fadeOut(function() {
              checkItemEl = $(this);

              checkItemEl.remove();
            });
        } else if (check_item.op === 'update') {
          checkItemEl = $(check_item.html);
          var oldCheckItemEl = $(".check-item[data-guid=" + check_item.guid + "]");

          oldCheckItemEl.replaceWith(checkItemEl);

          if (checkItems.data('sortable') === true) {
            checkItems.prepend(checkItems.find('.check-item').sort(ascFn));
          }

          tower.initCheckItem(checkItemEl, { willRemoveLink: $('#page-todo').length ? true : false });
        }

        if (checkItemEl && checkItemEl.length) {
          tower.highlight(checkItemEl);
        }
      } else if (pageId === 'page-member' &&
                 check_item.assignee_guid &&
                 new RegExp(check_item.assignee_guid).test(location.href)) {
        memberCheckItemEvent(check_item)
      }
    });

    // todolist_copy
    mychannel.bind('todolist_copy', function(todolist) {
      if (todolist.conn_guid != connectionId) {
        return;
      }

      if ($('.simple-loading').length !== 0) {
        simple.loading.destroy()
      }

      const todolistDetail = document
        .querySelector(`tr-project-kanban-todolist-detail[guid="${todolist.guid}"]`);
      if (todolistDetail) {
        todolistDetail.showCopiedMessage({
          projectName: todolist.proj_name,
          todolistUrl: todolist.kanbanTodolistUrl,
        });
        return;
      }

      const $form = $('.form-copy')

      const $actions = $form.closest('.detail-actions')
      const $page = $actions.closest('.page-inner')

      const $mask = $('<div class="mask hide"></div>')
      const successTpl = '<div class="page-tip action hide">复制完成，这个条目已被复制到 <em>{{ proj_name }}</em> 中，<a data-nocache data-stack data-stack-root data-parent-name="{{ proj_name }}" data-parent-url="{{ proj_url }}" href="{{ url }}">现在就去查看 →</a></div>'
      const $tip = $(simple.tpl(successTpl, todolist))

      $actions.fadeOut('fast', function() {
        $actions.remove()
      });

      $mask.appendTo($page).fadeIn(function() {
        $tip.appendTo($page).slideDown()
      });
    });

    // todolist_move
    mychannel.bind('todolist_move', function(todolist) {
      if (todolist.conn_guid != connectionId) {
        return;
      }

      if ($('.simple-loading').length !== 0) {
        simple.loading.destroy()
      }

      const todolistDetail = document
        .querySelector(`tr-project-kanban-todolist-detail[guid="${todolist.guid}"]`);
      if (todolistDetail) {
        todolistDetail.showMovedMessage({
          projectName: todolist.proj_name,
          todolistUrl: todolist.kanbanTodolistUrl,
        });
        return;
      }

      const $form = $('.form-move')

      const $actions = $form.closest('.detail-actions')
      const $page = $actions.closest('.page-inner')

      const $mask = $('<div class="mask hide"></div>')
      const successTpl = '<div class="page-tip action hide">移动完成，这个条目已被移动到 <em>{{ proj_name }}</em> 中，<a data-nocache data-stack data-stack-root data-parent-name="{{ proj_name }}" data-parent-url="{{ proj_url }}" href="{{ url }}">现在就去查看 →</a></div>'
      const $tip = $(simple.tpl(successTpl, todolist))

      $actions.fadeOut('fast', function() {
        $actions.remove()
      });

      $mask.appendTo($page).fadeIn(function() {
        $tip.appendTo($page).slideDown()
      });
    });

    // permissions_changed
    mychannel.bind('permissions_changed', function(permissions) {
      tower.permissions = permissions;
    });

    // calendar event export
    mychannel.bind('calendar_export', function(result) {
      if (result.conn_guid != connectionId) {
        return;
      }

      if ($('.simple-loading').length !== 0) {
        simple.loading.destroy();
        if (result.url) {
          window.open(result.url);
        }
      }
    });

    // 工时导出
    mychannel.bind('project_export_time_logs', function(result) {
      if (result.conn_guid != connectionId) return;

      if (result.url) {
        window.simple.loading.destroy();
        window.open(result.url);
      }
    });

    // 初始化团队欢迎项目
    mychannel.bind('INIT_WELCOME_PROJECTS', function(result) {
      const teamPreparation = document.querySelector('tr-team-preparation');
      if (teamPreparation) {
        teamPreparation.prepared = result.initialized;
      }
    });

    // 模板复制到团队

    // 任务筛选器导出
    mychannel.bind('filters_export', function(result) {
      if (result.conn_guid != connectionId) return;

      if (result.url) {
        window.simple.loading.destroy();
        window.open(result.url);
      }
    });

    // 批量操作表格视图
    mychannel.bind('TODOS_BATCH_TASK', function(result) {
      const { todo } = result

      if (todo) {
        const actionMapping = {
          'move_todo': 'move',
          'update_todo': 'update',
          'delete_todo': 'destroy'
        };

        resourceSubject('todo').next(actionMapping[result.action], {
          id: result.todo.id,
          guid: result.todo.guid,
          rowData: result.todo.row_data,
          isBatchTask: true,
        });
      }

      var loading = document.querySelector('.batch-task-loading');
      if (!loading || loading.dataset.finished) return;

      $.getJSON(result.task_url).then((result) => {
        const { status, finished_count, total_count } = result.task;

        if (status === "ongoing") {
          loading.textContent = `批量处理中 (${finished_count} / ${total_count})...`;
        } else {
          loading.dataset.finished = true;
          window.simple.loading.destroy();
        }
      });
    });

    // 任务复制
    mychannel.bind('TODO_COPY', function(result) {
      if (result.conn_guid != connectionId) {
        return;
      }

      if (result.success) {
        const grid = document.querySelector('tr-todo-grid');
        if (grid) {
          result.new_todo_guids.forEach((new_todo_guid) => {
            $.ajax({
              url: `/projects/${result.proj_guid}/list/todo_row`,
              method: 'get',
              data: {
                todo_guid: new_todo_guid,
                group_by: 'todolist',
                group_value: result.list,
                copy_from: result.copy_from,
              },
              dataType: 'script',
            });
          })
        }

        const pageOpened = document.querySelector('.tr-page[opened]');
        const $wrapper = $('.todo-page-main');
        window.simple.loading.destroy();
        const successTpl = `
        <div class="page-tip action hide">
            该任务已成功复制 {{ count }} 份
            <a data-nocache data-stack data-stack-root
                ${pageOpened ? '' : 'data-parent-name="{{ proj_name | encodeHtml }}"'}
                ${pageOpened ? '' : 'data-parent-url="{{ proj_url }}"'}
                href="{{ ${pageOpened ? 'proj_url' : 'url'} }}">
              ${pageOpened ? '' : '，现在就去查看 →'}
            </a>
        </div>
        `;

        const $tip = $(window.simple.tpl(successTpl, result));

        $tip.prependTo($wrapper).slideDown();
        setTimeout(() => {
          $tip.slideUp();
        }, 5000);
      } else {
        window.simple.loading.destroy();
        window.simple.dialog.message({ content: result.msg });
      }
    });

    // zoom
    mychannel.bind('ZOOM_CREATE_MEETING', function(result) {
      if (result.success) {
        var zoom = document.querySelector('tr-zoom');
        if (zoom) zoom.openResultDialog({ zoomUrl: result.zoom_url });
      } else if (result.status == 'retry') {
        $('.simple-global-loading span').text(result.msg)
      } else {
        window.simple.loading.destroy();
        window.simple.dialog.message({content: result.msg});
      }
    });

    // 任务导入
    mychannel.bind('tr_import_import_progress', (result) => {
      let currentImportNum = 0;

      const loadingMsg = (number) => {
        if (number > currentImportNum) currentImportNum = number;
        return `正在导入第 ${number} 条任务...`;
      }

      const successDialog = document.querySelector('.success-dialog');
      const loading = $('.simple-global-loading').data('loading');
      if (loading && result.status === 'ongoing') {
        loading.loadingEl.text(loadingMsg(result.finishedCount));
      } else if (result.status === 'completed') {
        successDialog.querySelector('.mdc-dialog__content').innerHTML = `已成功导入${result.finishedCount}条任务`;
        successDialog.open();
        window.simple.loading.destroy();
      }
    })

    // 知识库资源移动
    mychannel.bind('tr_repository_movement', (result) => {
      setTimeout(function() {
        simple.loading.destroy();
      }, 500);

      if (result.success) {
        const nav = document.querySelector('tr-repository-nav');
        if (nav) nav.update();
        if (result.silent) return;
        tower.stack.load(result.url, {
          nocache: true,
          replace: true,
          root: true,
          fluid: true
        });
      } else {
        simple.dialog.message({ content: result.msg });
      }
    });

    // 知识库导入资源
    mychannel.bind('tr_repository_import', (result) => {
      setTimeout(function() {
        simple.loading.destroy();
      }, 500);

      if (result.success) {
        const nav = document.querySelector('tr-repository-nav');
        if (nav) nav.update();
        tower.stack.load(location.href, {
          nocache: true,
          replace: true,
          root: true,
          fluid: true
        });
      } else {
        simple.dialog.message({ content: result.msg });
      }
    });

    // 知识库批量删除
    mychannel.bind('tr_repository_destruction', (result) => {
      setTimeout(function() {
        simple.loading.destroy();
      }, 500);

      if (result.success) {
        const nav = document.querySelector('tr-repository-nav');
        if (nav) nav.update();
        tower.stack.load(location.href, {
          nocache: true,
          replace: true,
          root: true,
          fluid: true
        });
      } else {
        simple.dialog.message({ content: result.msg });
      }
    });
  });

  //未读通知数字
  tower.updateNoticeCount = function(count) {
    if (!$.isNumeric(count)) {
      return
    }

    $("#notification-count").toggleClass("unread", count > 0)
      .data('unread-count', count)
      .find('.num').text(count > 99 ? '···' : count);

    if (tower.notificationsBox && count == 0) {
      tower.notificationsBox.reset()
    }

    tower.updateFavicon(count)

    // Electron App
    if (window.Bridge) {
      window.Bridge.setDockBadge(count)
    }
  };

  //桌面通知
  function d18n(data) {
    if (tower.d18n_enabled && tower.d18n.permitted()) {
      if (simple.util.storage.get('last_d18n_id') * 1 === data.late_id) {
        return;
      }

      simple.util.storage.set('last_d18n_id', data.late_id);

      tower.d18n.show({
        title: data.late_notice,
        content: data.late_content,
        url: data.late_url,
        team: tower.team.guid,
        replaceId: data.late_id
      });
    }
  }

  //通知弹出框
  function updateUnreadPopover(data) {
    var listEl = $(".noti-pop-list"),
        emptyEl = $(".noti-pop-empty");

    if (!listEl.length) {
      return
    }

    if (tower.notificationsBox) {
      if (data.op === 'ADD') {
        tower.notificationsBox.receiveNew()
      } else if (data.op === 'DEL') {
        tower.notificationsBox.markRead([data.target_guid])
      } else if (data.op === 'DEL_BY_TARGETS') {
        tower.notificationsBox.markRead(data.target_guids)
      } else if (data.op === 'CLR') {
        tower.notificationsBox.markAllRead()
      }
    } else {
      $('#notification-count').one('click', function (e) {
        e.preventDefault()
        location.reload()
      })
    }

    // var unreadCount = listEl.children().length;
    // tower.updateNoticeCount(unreadCount);
  }

  function ascFn(a, b) {
    var p1 = $(a).data("sort") * 1,
        p2 = $(b).data("sort") * 1;
    return p1 - p2;
  }

  function descFn(a, b) {
    var p1 = $(a).data("sort") * 1,
        p2 = $(b).data("sort") * 1;
    return p2 - p1;
  }

  // handle the todo event in member page
  function memberTodoEvent(todo) {
    var oldEl = $('.member-todos').find(".todo[data-guid=" + todo.guid + "]").closest('.expanded-todo');

    // 正在拖动就不处理
    if (oldEl.hasClass('ui-sortable-helper')) {
      return
    }

    if (todo.op === 'delete') {
      oldEl.remove();
    } else if (/create|update/.test(todo.op)) {
      var memberGuid = $('.workspace .page:last .page-inner').data('guid');
      var todoEl = $(todo.expanded_todo_html);
      var assigneeGuid = todoEl.find('.todo').data('assignee-guid') || todoEl.find('.todo-assign-due .assignee').data('guid');

      if (assigneeGuid !== memberGuid) {
        var isParticipant = todoEl.find('.check-item[data-assignee-guid="' + memberGuid + '"]').length > 0

        if (!isParticipant) {
          if (todo.op === 'update') {
            oldEl.remove();
            // tower.memberTodosFilter()
          }
          return;
        }
      }

      if (oldEl.length) {
        oldEl.replaceWith(todoEl);
      } else if ($('.member-todos[data-view-by="gtd_box"]').length) {
        $('.box-new .todos').append(todoEl);
      } else {
        $('.member-todos .todolist').append(todoEl);
      }
      tower.initExpandedTodo(todoEl, memberGuid);

      var $todos = todoEl.closest('.todos-uncompleted');
      if ($todos.is('.ui-sortable') && $todos.data('ui-sortable')) {
        $todos.sortable('refresh');
      }
    }

    tower.memberTodosFilter()

    if (todoEl && todoEl.length) {
      tower.highlight(todoEl);
    }
  }

  function handleSubTodoEvent(todo) {
    const todoEl = $(todo.html);
    const subtodos = $('tr-todo-page-subtodos');
    const oldTodoEl = $('.todo[data-guid=' + todo.guid + ']');
    const parentTodo = $('.todo[todo-guid=' + todo.parent_id + ']');

    if (parentTodo.length === 0) return

    if (todo.op === 'create') {
      if (oldTodoEl.length) {
        oldTodoEl.remove();
      }
      subtodos.find('.sort-subtodos').append(todoEl);
    } else if (todo.op === 'delete') {
      if (oldTodoEl.length) {
        oldTodoEl.fadeOut(() => {
          oldTodoEl.remove();
        });
      }
    } else if (todo.op === 'update') {
      const oldTodoEl = $('.todo[data-guid=' + todo.guid + ']');
      const todosCompleted = $('.sub-todos .todos-completed');
      // 布局为 grouy_by_completed 时, 更改完成状态,需将todo移动到对应的状态group里
      if (todosCompleted.length > 0) {
        const oldIsCompleted = oldTodoEl.hasClass('completed');
        const newIsCompleted = todoEl.hasClass('completed');
        // Completed不发生变化时
        if (oldIsCompleted === newIsCompleted) {
          oldTodoEl.hide('fast').before(todoEl).remove();
        } else {
          // 变成已完成
          if (newIsCompleted) {
            oldTodoEl.fadeOut(() => {
              oldTodoEl.remove();
              subTodos.find('.todos-completed').prepend(todoEl);
            });
          }else {
            // 变成未完成
            oldTodoEl.fadeOut(() => {
              oldTodoEl.remove();
              subTodos.find('.todos-uncompleted').append(todoEl);
            });
          }
        }
      } else {
        // 布局为 sequence 时,不改变todo的位置
        oldTodoEl.hide('fast').before(todoEl).remove();
      }

      tower.adjustTodo(todoEl);

      if (todoEl && todoEl.length) {
        tower.highlight(todoEl);
      }
    }
  }

  function memberCheckItemEvent(checkItem) {
    var $oldCheckItem = $('.member-todos').find(".check-item[data-guid=" + checkItem.guid + "]"),
        $expandedTodo, $checkItem;

    if ($oldCheckItem.length) {
      $expandedTodo = $oldCheckItem.closest('.expanded-todo');
    } else {
      $expandedTodo = $('.member-todos').find(".todo[data-guid=" + checkItem.todo_guid + "]").closest('.expanded-todo');
    }

    // 正在拖动就不处理
    if ($expandedTodo.is('.ui-sortable-helper')) return;

    if (/create|update/.test(checkItem.op)) {
      var $currentPage = $('.workspace .page:last .page-inner');
      var memberGuid = $currentPage.data('guid');
      var assigneeGuid = checkItem.assignee_guid;

      $checkItem = $(checkItem.html);

      if (assigneeGuid !== memberGuid) {
        if (checkItem.op === 'update') {
          $oldCheckItem.remove();
        }
      } else {
        if ($oldCheckItem.length) {
          $oldCheckItem.replaceWith($checkItem);
        } else {
          if ($expandedTodo.length) {
            $expandedTodo.find('.todo-check-items').append($checkItem);
          } else {
            var $newExpandedTodo = $(checkItem.expanded_todo_html);

            $('.box-new .todos').append($newExpandedTodo);
            tower.initExpandedTodo($newExpandedTodo, memberGuid);
          }
        }
      }

      if ($checkItem.closest('.todos-uncompleted').is('.ui-sortable')) {
        $checkItem.closest('.todos-uncompleted').sortable('refresh');
      }

      tower.initCheckItem($checkItem, { willRemoveLink: $('#page-todo').length ? true : false });
    } else if (checkItem.op === 'delete') {
      var hasOtherCheckItems = $oldCheckItem.siblings('.check-item').length > 0;

      if ($expandedTodo.is('.participant') && !hasOtherCheckItems) {
        $expandedTodo.remove();
      } else {
        var checkItemGuid = $oldCheckItem.data('guid');

        $oldCheckItem.remove();
        $expandedTodo.trigger('destroyCheckItem', [checkItemGuid]);
      }
    }

    tower.memberTodosFilter()

    if ($checkItem && $checkItem.length) {
      tower.highlight($checkItem);
    } else if ($expandedTodo && $expandedTodo.length) {
      tower.highlight($expandedTodo);
    }
  }

})(jQuery);
